function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 40,
  width: 40,
  height: 40,
  rx: 20,
  transform: "rotate(-90 0.5 40)",
  fill: "#150847"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8997 15.7433C22.1786 16.0222 22.6309 16.0222 22.9098 15.7433L23.5952 15.0579L23.5952 24.762C23.5952 25.1565 23.915 25.4763 24.3095 25.4763C24.704 25.4763 25.0238 25.1565 25.0238 24.762L25.0238 15.0579L25.7092 15.7433C25.9881 16.0222 26.4404 16.0222 26.7193 15.7433C26.9983 15.4643 26.9983 15.0121 26.7193 14.7331L24.8146 12.8284C24.5356 12.5494 24.0834 12.5494 23.8044 12.8284L21.8997 14.7331C21.6207 15.0121 21.6207 15.4643 21.8997 15.7433Z",
  fill: "#FFCDEC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4047 24.9423L18.0901 24.2569C18.3691 23.978 18.8214 23.978 19.1003 24.2569C19.3792 24.5359 19.3792 24.9881 19.1003 25.2671L17.1955 27.1718C16.9166 27.4508 16.4643 27.4508 16.1854 27.1718L14.2806 25.2671C14.0017 24.9881 14.0017 24.5359 14.2806 24.2569C14.5596 23.978 15.0118 23.978 15.2908 24.2569L15.9762 24.9423L15.9762 15.2382C15.9762 14.8437 16.296 14.5239 16.6905 14.5239C17.0849 14.5239 17.4047 14.8437 17.4047 15.2382L17.4047 24.9423Z",
  fill: "#FFCDEC"
});

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.99ec3c59.svg";
export { ForwardRef as ReactComponent };